module.exports = __webpack_public_path__ + "static/fonts/Fact-Regular.60f42ab.woff";